import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e301242a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "box-header" }
const _hoisted_3 = { class: "box-flag" }
const _hoisted_4 = { class: "box-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.flagName), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1)
    ]),
    _renderSlot(_ctx.$slots, "list", {}, undefined, true)
  ]))
}